import api from './api-v1';

// Create new feuille
export const createFeuille = async (data) => {
  try {
    const response = await api.post('/feuilles', data);
    return response.data;	
  } catch (error) {
    console.error('Error creating feuille:', error);
    throw error;
  }
};

// Get all feuilles
export const getFeuilles = async () => {
  try {
    const response = await api.get('/feuilles');
    return response.data;
  } catch (error) {
    console.error('Error fetching feuilles:', error);
    throw error;
  }
};

// Get feuille by id
export const getFeuilleID = async (id) => {
  try {
    const response = await api.get(`/feuilles/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching feuille:', error);
    throw error;
  }
};

// Update feuille by id
export const updateFeuille = async (id, data) => {
  try {
    const response = await api.put(`/feuilles/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating feuille:', error);
    throw error;
  }
};

// Delete feuille by id
export const deleteFeuille = async (id) => {
  try {
    const response = await api.delete(`/feuilles/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting feuille:', error);
    throw error;
  }
};

// Get feuille columns
export const getFeuilleColumns = async (feuilleId) => {
  try {
      const response = await api.get(`/feuille_columns/${feuilleId}`);
      return response.data;
  } catch (error) {
      console.error('Error fetching feuille columns:', error);
      throw error;
  }
};

